export default {
    getMessageWithKey: (state) => (key) => {
        return state.sharedmessages[key];
    },
    sharedmessages(state) {
        return state.sharedmessages;
    },
    sharedmessagestatus(state) {
        return state.sharedmessagestatus;
    }
    

}